import { useMemo, useState } from 'react'
import { TILE_LAYOUT_TYPE } from 'src/consumer/constants'
import { CardListContainer } from '../../CardList/CardListStyle'
import ArticleLayoutCard from './layoutCards/ArticleLayoutCard'
import SpreadBoardCard from './layoutCards/SpreadBoardCard'
import SquareMidTileComponent from './layoutCards/SquareMidCard'

export default function CardListV2({ headingLogicAndData, tileLogicAndData }) {
  const [areTileItemsHovered, setAreTileItemsHovered] = useState(false)

  const TileLayoutComponent = useMemo(() => {
    console.log(tileLogicAndData?.tileData?.layout)
    switch (tileLogicAndData?.tileData?.layout) {
      case TILE_LAYOUT_TYPE.articleLayout:
        return ArticleLayoutCard
      case TILE_LAYOUT_TYPE.spreadBoard:
        return SpreadBoardCard
      default:
        return SquareMidTileComponent
    }
  }, [tileLogicAndData?.tileData?.layout])

  return (
    <>
      <CardListContainer
        onMouseEnter={() => setAreTileItemsHovered(true)}
        onMouseLeave={() => setAreTileItemsHovered(false)}
      >
        <TileLayoutComponent
          headingLogicAndData={headingLogicAndData}
          areTileItemsHovered={areTileItemsHovered}
          logicAndData={{ ...tileLogicAndData, ...tileLogicAndData?.tileData }}
        />
      </CardListContainer>
    </>
  )
}
